import $ from 'jquery';

export default function risultati() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const query = urlParams.get('query');
	var page = 1;

	function searchResults(query, page) {
		
		var data = {
			query: query,
			page: {
				size: 10,
				current: page
			}
		};
		
		var settings = {
			"url": "https://ariadne-deployment.ent.eu-west-1.aws.found.io/api/as/v1/engines/bcp-search-engine/search",
			"method": "POST",
			"timeout": 0,
			"headers": {
				"Authorization": "Bearer search-f2m7t34qrvuziapr6msj4upz",
				"Content-Type": "application/json"
			},
			"data": JSON.stringify(data)
		};

		$.ajax(settings).done(function (response) {
			console.log(response.results);
			
			$(".search-results .loading-spinner").hide();

			if(response.results.length > 0) {
				$("#search-results").empty();
				$("#search-results-pag").empty();
				
				let risultati = response.results.map((item) => {
					let titleResult = item.title.raw.split(" - ")[0];
					let urlResult = item.url.raw;
					// let metaDescriptionResult = item.meta_description && item.meta_description.raw;
					let bodyResult = item.body_content && item.body_content.snippet == null ? "" : item.body_content.snippet;
					// let abstractResult = metaDescriptionResult ? metaDescriptionResult : bodyResult;
					
					$("#search-results").append(`
						<div class="box-result">
							<div class="box-result__title">
								<a href="${urlResult}" title="Vai alla pagina: ${titleResult}" class="box-result__link">${titleResult}</a>
							</div>
							<div class="box-result__abstract">${bodyResult}</div>
						</div>
					`);
				});
				
				if(response.meta.page.total_pages > 1) {
					$("#search-results-pag").append(`<div class="bcp-pagination mt-2"><div class="d-flex justify-content-center"><div class="d-flex justify-content-center flex-wrap bcp-pagination__btn"></div></div></div>`);
					for (let i = 0; i < response.meta.page.total_pages; i++) {
						$(".bcp-pagination__btn").append(`
							<button type="button" data-page="${i+1}" ${response.meta.page.current == i+1 ? 'disabled="disabled"' : ''} title="Vai a pagina ${i+1}" class="bcp-pagination__link${response.meta.page.current == i+1 ? ' bcp-pagination__link--current' : ''}">${i+1}</button>
						`);
					}
				}
						
			} else {
				$("#search-results").append(`<div class="no-results">Nessun risultato per la ricerca effettuata.</div>`);
			}
			
		});
	}

	$(document).on('click', '.bcp-pagination__link', function() {
		var page = $(this).data("page");
		
		$("#search-results").empty();
		$("#search-results-pag").empty();
		$(".search-results .loading-spinner").show();

		window.scrollTo(0, 200);

		searchResults(query, page);
	});
  
  $( document ).ready(function() {
    if($('#search-results').length > 0) {
      searchResults(query, page);
    }
  });  
}